import { TripDateTripManagerMapping } from '../../lib/types/models/trip-booking/trip-date'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripDateTripManagers(id: number) {
  return restApiClient
    .url(constructApiUrl(API.tripDates.getTripManagers.url, { id }))
    .get<TripDateTripManagerMapping>()
}
